import {
  ColDef
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, Pagination, Tooltip } from "antd";
import viVN from "antd/locale/vi_VN";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import ".././stylestabs.scss";

import { ICustomer, ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { capitalizeEachWord, CustomLoadingOverlayTable, dataPagination, getValueByFieldCode, getWidthFromHeader, getWidthFromHeaderV2, NOOP, renderValueAsJSX } from "../../../../until";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";

import { formatNumber } from "../../../../services/mixin";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { NodataTable } from "../../../../components/NoDataTable";
import FilterHeaderCar, { IDataDefaulFilterCar } from "./Components/FilterHeaderCar/FilterHeaderCar";
import { NO_DATA } from "../../../../env";
import { Link } from "react-router-dom";
import { NO_VIEW } from "../../../../services/data";

export type ContactInformationHandle = {
  getFilters: () => {
    dataFilterActive: FlattenedField[]; dataFilterNoActive: ListField[];
  };
  setFilters: (active: FlattenedField[], noActive: ListField[]) => void; // 👈 thêm hàm này
};

export type HeaderActions = {
  setDataFilterList: (dataFilterList: IDataDefaulFilterCar) => void;
};

export type FilterHeaderExtras = {
  dataFilterList?: IDataDefaulFilterCar;
  customerId?: number
  setDataFilterList: (dataFilterList: IDataDefaulFilterCar) => void;
};
export const generateColumnsFromCodesAgGridReactRecordCar = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  actionColumn?: ColDef<any, any>,

  onToggleStatus?: (id: number, next: boolean, rowData: any) => void,
  headerActions: HeaderActions = { setDataFilterList: NOOP },
  listFilterIcon?: string[], dataFilterList?: IDataDefaulFilterCar,
  customerId?: number,
  listFieldCodeLink?: string[]
): ColDef[] => {
  const baseColumns = codes
    ?.map((code) => {
      const field = fields.find((f) => f.fieldCode === code);
      if (!field) return null;
      const headerExtras: FilterHeaderExtras & { listFilterIcon?: string[] } = {
        dataFilterList, listFilterIcon,
        setDataFilterList: headerActions.setDataFilterList,
        customerId

      };
      const STATUS_FIELDS = ["interaction_vehicle_status", "interaction_group_status_name", "interaction_customer_last_assessment", "status", "customer_assessment", "customer_last_assessment", "campaign_type_of_interaction"];
      return {
        headerName: field.fieldLabel || '',
        headerComponent: FilterHeaderCar,
        // headerComponentParams: {
        //   listFilterIcon,
        // },
        headerComponentParams: headerExtras, // chỉ extras
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        width: getWidthFromHeaderV2(field.fieldLabel || ''),
        cellRenderer: (params: any) => {
          if (STATUS_FIELDS.includes(field.fieldCode)) {

            const currentField = params.data.fields.find(
              (f: any) => f.fieldCode === field.fieldCode
            )
            const colors = currentField?.additionalData?.colors || params.data?.[`${field.fieldCode}__meta`]?.colors

            return (
              <div
                className="custom-page-css flex items-center  rounded w-full h-full "

              >
                <span className="custom-page-css flex items-center justify-center rounded w-fit h-8 p-2"
                  style={{
                    border: `1px solid ${colors?.border}`,
                    color: `${colors?.text}`,
                    background: `${colors?.bg}`,
                  }}
                >{params.value || NO_DATA}</span>
              </div>
            );
          }
          // console.log(customerId, params?.data.customerId, listFieldCodeLink?.includes(field.fieldCode), params)
          if (customerId !== params?.data.contactId && params?.data.contactId) {
            if (listFieldCodeLink?.includes(field.fieldCode)) {
              return (
                <Link
                  style={{
                    color: "#1677ff",
                    cursor: "pointer",
                    fontWeight: 500,
                    textTransform: 'capitalize'
                  }}
                  to="/customer/list/edit"
                  state={{
                    id: params?.data.contactId,
                  }}
                >
                  {(capitalizeEachWord(String(getValueByFieldCode(params.data.fields, field.fieldCode))) === 'Null' ? NO_DATA : capitalizeEachWord(String(getValueByFieldCode(params.data.fields, field.fieldCode)))) ?? NO_DATA}
                </Link>
              );
            }
          }

          if (['repair_description', 'content'].includes(field.fieldCode)) {
            return (
              <div
                className="custom-page-css flex items-center  rounded w-full h-full "
              >
                <Tooltip
                  placement="right"
                  title={params.value || NO_DATA} >
                  <span className="custom-page-css flex items-center justify-center rounded p-2"
                  >{params.value || NO_DATA}</span>
                </Tooltip>
              </div >
            );
          }
          return renderValueAsJSX(params.value, field.fieldCode);
        }
      } as ColDef;
    })
    .filter(Boolean) as ColDef[];

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
};

interface Prop {
  loadingTableDetail: boolean

  dataFieldsActive: FlattenedField[]
  data: ICustomer[]
  pagination: IPagination

  onPaginationChange: (page: number, pageSize: number) => void
}

const ContactInformation = forwardRef<ContactInformationHandle, Prop>(
  (
    {
      loadingTableDetail, dataFieldsActive, data, pagination,
      onPaginationChange

    }, ref
  ) => {
    useEffect(() => {

    }, []);


    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

    //#region Cấu hình bảng
    const memoizedColumnDefs = useMemo(() => {
      return generateColumnsFromCodesAgGridReactRecordCar(
        columnsMapShow, dataFieldsActive, undefined,
        () => { }
      );
    }, [columnsMapShow, dataFieldsActive]);

    const tableData = useMemo(() => {
      return data.map((item) => {
        const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
          acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
          return acc;
        }, {});

        return {
          ...item,
          key: item.id.toString(),
          ...fieldValues
        };
      });
    }, [data]);


    useEffect(() => {
      const codes = dataFieldsActive.map((f) => f.fieldCode);
      setColumnsMapShow(codes);
    }, [dataFieldsActive]);

    //#endregion

    // useImperativeHandle(ref, () => ({
    //   getFilters: () => ({
    //     dataFilterActive,
    //     dataFilterNoActive,
    //   }), setFilters: (dataFilterActive, dataFilterNoActive) => {
    //     setDataFilterActive(dataFilterActive);
    //     setDataFilterNoActive(dataFilterNoActive);
    //   },
    // }));
    return (
      <>
        <div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
          <div className="ag-theme-alpine custom-table-ag custom-css-table"
            //  style={{ width: '100%', height: 610 }}
            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
          >
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={55}
              overlayNoRowsTemplate={NodataTable}
              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
              }}
              loading={loadingTableDetail}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              // onSelectionChanged={onSelectionChanged}
              // Performance optimizations
              suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
              suppressRowVirtualisation={false} // Giữ row virtualization
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              // Thêm các props sau để cải thiện scroll
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
            />
          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </>
    );
  })

export default ContactInformation;
